import { initializeApp, getApps, FirebaseOptions } from 'firebase/app'

// Initialize Firebase
const firebase_app = (firebaseConfig: FirebaseOptions) =>
  getApps()?.find(it => it.options.projectId === firebaseConfig.projectId) ||
  initializeApp(firebaseConfig, firebaseConfig.projectId)

export default firebase_app
